import { render, staticRenderFns } from "./keepRecordDetail.vue?vue&type=template&id=66df3a68&"
import script from "./keepRecordDetail.vue?vue&type=script&lang=js&"
export * from "./keepRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./keepRecordDetail.vue?vue&type=style&index=0&id=66df3a68&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports